// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file plugnmeet_common.proto (package plugnmeet, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Codec, ParticipantInfo, TrackInfo } from "./livekit_models_pb";
import { file_livekit_models } from "./livekit_models_pb";
import type { RoomArtifactWebhookEvent } from "./plugnmeet_room_artifacts_pb";
import { file_plugnmeet_room_artifacts } from "./plugnmeet_room_artifacts_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plugnmeet_common.proto.
 */
export const file_plugnmeet_common: GenFile = /*@__PURE__*/
  fileDesc("ChZwbHVnbm1lZXRfY29tbW9uLnByb3RvEglwbHVnbm1lZXQi1QQKEUNvbW1vbk5vdGlmeUV2ZW50EhIKBWV2ZW50GAEgASgJSACIAQESLQoEcm9vbRgCIAEoCzIaLnBsdWdubWVldC5Ob3RpZnlFdmVudFJvb21IAYgBARIyCgtwYXJ0aWNpcGFudBgDIAEoCzIYLmxpdmVraXQuUGFydGljaXBhbnRJbmZvSAKIAQESOgoOcmVjb3JkaW5nX2luZm8YBCABKAsyHS5wbHVnbm1lZXQuUmVjb3JkaW5nSW5mb0V2ZW50SAOIAQESOgoOc3BlZWNoX3NlcnZpY2UYBSABKAsyHS5wbHVnbm1lZXQuU3BlZWNoU2VydmljZUV2ZW50SASIAQESJgoFdHJhY2sYBiABKAsyEi5saXZla2l0LlRyYWNrSW5mb0gFiAEBEjEKCWFuYWx5dGljcxgHIAEoCzIZLnBsdWdubWVldC5BbmFseXRpY3NFdmVudEgGiAEBEj8KDXJvb21fYXJ0aWZhY3QYCCABKAsyIy5wbHVnbm1lZXQuUm9vbUFydGlmYWN0V2ViaG9va0V2ZW50SAeIAQESDwoCaWQYCSABKAlICIgBARIbCgpjcmVhdGVkX2F0GAogASgDQgIwAUgJiAEBQggKBl9ldmVudEIHCgVfcm9vbUIOCgxfcGFydGljaXBhbnRCEQoPX3JlY29yZGluZ19pbmZvQhEKD19zcGVlY2hfc2VydmljZUIICgZfdHJhY2tCDAoKX2FuYWx5dGljc0IQCg5fcm9vbV9hcnRpZmFjdEIFCgNfaWRCDQoLX2NyZWF0ZWRfYXQi4QIKD05vdGlmeUV2ZW50Um9vbRIQCgNzaWQYASABKAlIAIgBARIUCgdyb29tX2lkGAIgASgJSAGIAQESGgoNZW1wdHlfdGltZW91dBgDIAEoDUgCiAEBEh0KEG1heF9wYXJ0aWNpcGFudHMYBCABKA1IA4gBARIeCg1jcmVhdGlvbl90aW1lGAUgASgEQgIwAUgEiAEBEiYKDmVuYWJsZWRfY29kZWNzGAYgAygLMg4ubGl2ZWtpdC5Db2RlYxIVCghtZXRhZGF0YRgHIAEoCUgFiAEBEh0KEG51bV9wYXJ0aWNpcGFudHMYCCABKA1IBogBAUIGCgRfc2lkQgoKCF9yb29tX2lkQhAKDl9lbXB0eV90aW1lb3V0QhMKEV9tYXhfcGFydGljaXBhbnRzQhAKDl9jcmVhdGlvbl90aW1lQgsKCV9tZXRhZGF0YUITChFfbnVtX3BhcnRpY2lwYW50cyKeAQoSUmVjb3JkaW5nSW5mb0V2ZW50EhEKCXJlY29yZF9pZBgBIAEoCRITCgtyZWNvcmRlcl9pZBgCIAEoCRIUCgxyZWNvcmRlcl9tc2cYAyABKAkSFgoJZmlsZV9wYXRoGAQgASgJSACIAQESFgoJZmlsZV9zaXplGAUgASgCSAGIAQFCDAoKX2ZpbGVfcGF0aEIMCgpfZmlsZV9zaXplIk8KElNwZWVjaFNlcnZpY2VFdmVudBIUCgd1c2VyX2lkGAMgASgJSACIAQESFwoLdG90YWxfdXNhZ2UYBCABKANCAjABQgoKCF91c2VyX2lkIjIKDkFuYWx5dGljc0V2ZW50EhQKB2ZpbGVfaWQYASABKAlIAIgBAUIKCghfZmlsZV9pZEKdAQoNY29tLnBsdWdubWVldEIUUGx1Z25tZWV0Q29tbW9uUHJvdG9QAVoyZ2l0aHViLmNvbS9teW5hcGFycm90L3BsdWdubWVldC1wcm90b2NvbC9wbHVnbm1lZXSiAgNQWFiqAglQbHVnbm1lZXTKAglQbHVnbm1lZXTiAhVQbHVnbm1lZXRcR1BCTWV0YWRhdGHqAglQbHVnbm1lZXRiBnByb3RvMw", [file_livekit_models, file_plugnmeet_room_artifacts]);

/**
 * @generated from message plugnmeet.CommonNotifyEvent
 */
export type CommonNotifyEvent = Message<"plugnmeet.CommonNotifyEvent"> & {
  /**
   * @generated from field: optional string event = 1;
   */
  event?: string | undefined;

  /**
   * @generated from field: optional plugnmeet.NotifyEventRoom room = 2;
   */
  room?: NotifyEventRoom | undefined;

  /**
   * @generated from field: optional livekit.ParticipantInfo participant = 3;
   */
  participant?: ParticipantInfo | undefined;

  /**
   * @generated from field: optional plugnmeet.RecordingInfoEvent recording_info = 4;
   */
  recordingInfo?: RecordingInfoEvent | undefined;

  /**
   * @generated from field: optional plugnmeet.SpeechServiceEvent speech_service = 5;
   */
  speechService?: SpeechServiceEvent | undefined;

  /**
   * @generated from field: optional livekit.TrackInfo track = 6;
   */
  track?: TrackInfo | undefined;

  /**
   * @generated from field: optional plugnmeet.AnalyticsEvent analytics = 7;
   */
  analytics?: AnalyticsEvent | undefined;

  /**
   * @generated from field: optional plugnmeet.RoomArtifactWebhookEvent room_artifact = 8;
   */
  roomArtifact?: RoomArtifactWebhookEvent | undefined;

  /**
   * @generated from field: optional string id = 9;
   */
  id?: string | undefined;

  /**
   * @generated from field: optional int64 created_at = 10 [jstype = JS_STRING];
   */
  createdAt?: string | undefined;
};

/**
 * Describes the message plugnmeet.CommonNotifyEvent.
 * Use `create(CommonNotifyEventSchema)` to create a new message.
 */
export const CommonNotifyEventSchema: GenMessage<CommonNotifyEvent> = /*@__PURE__*/
  messageDesc(file_plugnmeet_common, 0);

/**
 * @generated from message plugnmeet.NotifyEventRoom
 */
export type NotifyEventRoom = Message<"plugnmeet.NotifyEventRoom"> & {
  /**
   * @generated from field: optional string sid = 1;
   */
  sid?: string | undefined;

  /**
   * @generated from field: optional string room_id = 2;
   */
  roomId?: string | undefined;

  /**
   * @generated from field: optional uint32 empty_timeout = 3;
   */
  emptyTimeout?: number | undefined;

  /**
   * @generated from field: optional uint32 max_participants = 4;
   */
  maxParticipants?: number | undefined;

  /**
   * @generated from field: optional uint64 creation_time = 5 [jstype = JS_STRING];
   */
  creationTime?: string | undefined;

  /**
   * @generated from field: repeated livekit.Codec enabled_codecs = 6;
   */
  enabledCodecs: Codec[];

  /**
   * @generated from field: optional string metadata = 7;
   */
  metadata?: string | undefined;

  /**
   * @generated from field: optional uint32 num_participants = 8;
   */
  numParticipants?: number | undefined;
};

/**
 * Describes the message plugnmeet.NotifyEventRoom.
 * Use `create(NotifyEventRoomSchema)` to create a new message.
 */
export const NotifyEventRoomSchema: GenMessage<NotifyEventRoom> = /*@__PURE__*/
  messageDesc(file_plugnmeet_common, 1);

/**
 * @generated from message plugnmeet.RecordingInfoEvent
 */
export type RecordingInfoEvent = Message<"plugnmeet.RecordingInfoEvent"> & {
  /**
   * @generated from field: string record_id = 1;
   */
  recordId: string;

  /**
   * @generated from field: string recorder_id = 2;
   */
  recorderId: string;

  /**
   * @generated from field: string recorder_msg = 3;
   */
  recorderMsg: string;

  /**
   * @generated from field: optional string file_path = 4;
   */
  filePath?: string | undefined;

  /**
   * @generated from field: optional float file_size = 5;
   */
  fileSize?: number | undefined;
};

/**
 * Describes the message plugnmeet.RecordingInfoEvent.
 * Use `create(RecordingInfoEventSchema)` to create a new message.
 */
export const RecordingInfoEventSchema: GenMessage<RecordingInfoEvent> = /*@__PURE__*/
  messageDesc(file_plugnmeet_common, 2);

/**
 * @generated from message plugnmeet.SpeechServiceEvent
 */
export type SpeechServiceEvent = Message<"plugnmeet.SpeechServiceEvent"> & {
  /**
   * @generated from field: optional string user_id = 3;
   */
  userId?: string | undefined;

  /**
   * @generated from field: int64 total_usage = 4 [jstype = JS_STRING];
   */
  totalUsage: string;
};

/**
 * Describes the message plugnmeet.SpeechServiceEvent.
 * Use `create(SpeechServiceEventSchema)` to create a new message.
 */
export const SpeechServiceEventSchema: GenMessage<SpeechServiceEvent> = /*@__PURE__*/
  messageDesc(file_plugnmeet_common, 3);

/**
 * @generated from message plugnmeet.AnalyticsEvent
 */
export type AnalyticsEvent = Message<"plugnmeet.AnalyticsEvent"> & {
  /**
   * @generated from field: optional string file_id = 1;
   */
  fileId?: string | undefined;
};

/**
 * Describes the message plugnmeet.AnalyticsEvent.
 * Use `create(AnalyticsEventSchema)` to create a new message.
 */
export const AnalyticsEventSchema: GenMessage<AnalyticsEvent> = /*@__PURE__*/
  messageDesc(file_plugnmeet_common, 4);

